import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import Navbar from './Components/Navbar';
import Hero from './Components/Hero';
import FluidSection from './Components/FluidSection';
import About from './Components/About';
import Services from './Components/Services';
import SocialLinks from './Components/SocialLinks';
import Footer from './Components/Footer';
import { gsap } from 'gsap';

function App() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const cursorRef = useRef(null);
  const cursorDotRef = useRef(null);

  useEffect(() => {
    // Custom GSAP Cursor Follower
    const handleMouseMove = (e) => {
      const { clientX, clientY } = e;
      if (cursorRef.current && cursorDotRef.current) {
        gsap.to(cursorRef.current, {
          x: clientX - 16,
          y: clientY - 16,
          duration: 0.4,
          ease: 'power2.out',
        });
        gsap.to(cursorDotRef.current, {
          x: clientX - 4,
          y: clientY - 4,
          duration: 0.1,
          ease: 'power2.out',
        });
      }
    };

    // Smooth scroll anchor link handler
    const handleSmoothScroll = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (target) {
        const href = target.getAttribute('href');
        if (href && href.startsWith('#')) {
          e.preventDefault();
          const id = href.slice(1);
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }
      }
    };

    // Scroll progress handler
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? (window.scrollY / totalHeight) * 100 : 0;
      setScrollProgress(progress);
    };

    window.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('click', handleSmoothScroll);
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('click', handleSmoothScroll);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="App">
      {/* Custom Glowing Cursor */}
      <div className="custom-cursor" ref={cursorRef} />
      <div className="custom-cursor-dot" ref={cursorDotRef} />

      {/* Dynamic Background Orbs */}
      <div className="bg-orb bg-orb--1" />
      <div className="bg-orb bg-orb--2" />
      <div className="bg-orb bg-orb--3" />

      {/* Scroll Progress Bar */}
      <div className="scroll-progress">
        <div className="scroll-progress-bar" style={{ width: `${scrollProgress}%` }} />
      </div>

      <Navbar />
      <Hero />
      <FluidSection />
      <About />
      <Services />
      <SocialLinks />
      <Footer />
    </div>
  );
}

export default App;
